// Helpers
import { getOutlinedPositionIcon } from "@/Common/helpers/Positions/icons";

// Layouts
import PageLayer from "@/Layouts/views/PageLayer";

// Layer
import Layer from "@PayPlans/views/Layers/Departments/Managers/Departmental";

const POSITION = "Service Director";

export default function Directors() {
	const Icon = getOutlinedPositionIcon({ position: POSITION });
	return (
		<PageLayer title={"Service Director Pay Plans"} icon={Icon}>
			<Layer position={POSITION} defaultSections={["service"]} />
		</PageLayer>
	);
}
